import { render, staticRenderFns } from "./ServicePageForm.vue?vue&type=template&id=4cfc53b0&scoped=true&lang=pug&"
import script from "./ServicePageForm.vue?vue&type=script&lang=js&"
export * from "./ServicePageForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicePageForm.vue?vue&type=style&index=0&id=4cfc53b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc53b0",
  null
  
)

export default component.exports